import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';
import { userProfileAction } from './getUserProfile.action';

export const updateBasicProfileAction = {
    updateBasicProfileHandler
};

function updateBasicProfileHandler(data) {
    return dispatch => {
        dispatch(request());
        userProfileService.updateBasicProfileHandler(data)
            .then(
                updateUserProfile => {
                    dispatch(userProfileAction.getUserProfileHandler())
                    dispatch(success(updateUserProfile));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_UPDATE_BASIC_PROFILE} }
    function success(updateUserProfile) { return { type: userProfileConstants.RECEIVE_UPDATE_BASIC_PROFILE, updateUserProfile } }
    function failure(error) { return { type: userProfileConstants.UPDATE_BASIC_PROFILE_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/updateBasicProfile.action.js